import { Controller } from "react-hook-form";
import TextField from "../../../text-field/text-field";
import { InputAdornment, Select, MenuItem } from "@mui/material";
import { useState } from "react";
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';


interface DynamicInputSelectProps {
  formControl: any;
  fieldArrayName: string;
  name: string;
  label?: string;
  placeholder?: string;
  defaultValue?: any;
  required?: boolean;
  disabled?: boolean;
  hidden?: boolean;
  options?: Array<{ label: string; value: any }>;
  inputType?: string;
}
const DynamicInputSelect = (props: DynamicInputSelectProps) => {
    const [defaultOption, setSelectOption] = useState(props.options[0].value); //need to be update 
    const handleOptionChange = (event: any) => {
        setSelectOption(event.target.value);
    };
    return (
        <Controller
            control={props.formControl}
            name={`${props.fieldArrayName}.${props.name}`}
            render={({ field, fieldState }) => (
                <TextField
                    {...field}
                    name={`${props.fieldArrayName}.${props.name}`}
                    fullWidth
                    label={props.label}
                    placeholder={props.placeholder}
                    multiline={props.is_multiline || false}
                    disabled={props.disabled}
                    required={props.is_required}
                    inputProps={{
                        step: props?.float_step || "0",
                        min: props.min_length || 0,
                        max: props.max_length || 1000,
                        inputMode: 'string',


                    }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment
                                position="start"
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderLeft: '1px solid rgba(0, 0, 0, 0.23)',
                                    padding: 1,
                                    height: '100%',
                                    borderBottomLeftRadius: 4,
                                    borderTopLeftRadius: 4,
                                    backgroundColor: 'rgba(245 , 245 , 245 )',
                                    margin: 0,
                                    boxSizing: 'border-box',
                                    borderRadius: 0,

                                }}

                            >
                                <Select
                                    value={defaultOption}
                                    onChange={handleOptionChange}
                                    sx={{
                                        height: '100%',
                                        '&:focus': {
                                            backgroundColor: 'rgba(245 , 245 , 245 )'   , // Prevent background color change on focus
                                        },
                                        '&:hover': {
                                            backgroundColor: 'rgba(245 , 245 , 245 )', // Prevent background color change on hover
                                        },
                                        '&:active': {
                                            backgroundColor: 'rgba(245 , 245 , 245)', // Prevent background color change on active
                                        },
                                        '&.Mui-focused': {
                                            backgroundColor: '#fff', // Override the focus background color
                                        },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#fff', // Prevent border color change on focus
                                        },
                                    }}
                                    variant="standard"
                                    disableUnderline

                                    IconComponent={KeyboardArrowDownOutlinedIcon}

                                >
                                    {props.options?.map((item: any, index: any) => (
                                        <MenuItem
                                            key={index}
                                            value={item.value}
                                            sx={{
                                                '&:hover': {
                                                    backgroundColor: 'rgba(245 , 245 , 245 )', // Prevent background color change on hover
                                                },
                                                '&.Mui-selected': {
                                                    backgroundColor: 'rgba(245 , 245 , 245)', // Prevent background color change on selection
                                                },
                                                '&.Mui-selected:hover': {
                                                    backgroundColor: 'rgba(245 , 245 , 245)', // Prevent background color change on selection hover
                                                },
                                            }}
                                        >
                                            {item.label}
                                        </MenuItem>
                                    ))}
                                </Select>

                            </InputAdornment>
                        )

                    }}

                    error={Boolean(fieldState.error?.message)}
                    helperText={fieldState.error?.message || ""}
                    onBlur={field.onBlur}
                    onChange={(e: any) => {
                        field.onChange(e.target.value)
                    }}
                />
            )}
        />
    )
}
export { DynamicInputSelect };
export default DynamicInputSelect;
